import { useState } from 'react';
import {
	FaChevronDown,
	FaClock,
	FaComments,
	FaEnvelope,
	FaGamepad,
	FaGlobe,
	FaPhone,
	FaShieldAlt,
} from 'react-icons/fa';

import '../App.css';

// Import images
import LogoImg from '@/assets/static-landing-pages/Logo.png';
import ShopifyImg from '@/assets/static-landing-pages/Shopify.png';
import AiShakehandImg from '@/assets/static-landing-pages/ai-shakehand.png';
import BulbImg from '@/assets/static-landing-pages/bulb.png';
import JoinImageImg from '@/assets/static-landing-pages/join-image.png';
import NegotiateGirlImg from '@/assets/static-landing-pages/negotiate-girl.png';
import RobotSlidesImg from '@/assets/static-landing-pages/robot-slides.png';
import UploadImg from '@/assets/static-landing-pages/upload.png';
import WorldImg from '@/assets/static-landing-pages/world.png';

function Merchants() {
	const [openFAQ, setOpenFAQ] = useState<number | null>(null);

	const toggleFAQ = (index: number) => {
		setOpenFAQ(openFAQ === index ? null : index);
	};

	const faqData = [
		{
			question: 'Do you have a Free Plan?',
			answer:
				"Yes, it's completely free to sign up and we offer a Free plan with no time limitation, as long as the number of negotiations limits to 1000. but we also offer more plans where you get access to a lot more features and more negotiations.",
		},
		{
			question: 'What kind of merchants are on Haggle?',
			answer:
				'A mix of big-name retailers and boutique brands across fashion, beauty, home, sport, electronics, travel and more. All vetted before joining.',
		},
		{
			question: 'Is Haggle safe to use?',
			answer:
				'Absolutely. Every merchant is vetted before joining, and all payments are processed through secure global payment platforms. Your card details are never stored by Haggle.',
		},
		{
			question: 'How often I should have events?',
			answer:
				'There are no limitation on number of events per month. You can create concurrent events for different products with allocating different margins. But we recommend you keep the hours short (4-6 hours) to create more FOMO for consumers and keep it exclusive.',
		},
		{
			question: 'Is Haggle just for bargain hunters?',
			answer:
				'No, Haggle is not a platform to sell things cheap, its an opportunity for merchants and customers to engage in a friendly dialog and make win-win deals.',
		},
		{
			question: 'Do you help us with sending us customers?',
			answer:
				'Yes, once a merchant creates a haggle event, we can post the products on our Haggle Hub where thousands of customer visit to look for next deal. We also promote their events on our social media to bring more customers to their events, resulting in more conversion and higher margins.',
		},
		{
			question: 'How customers find us?',
			answer:
				"Once you create a Negotiation Event, you can let your customers know about the event. We also help you with posting those events/products on our website and social media which redirect the customers back to your website again. It's all about more conversion at your website.",
		},
		{
			question: 'What is the success fee?',
			answer:
				'Haggle enables merchants to achieve higher margins that they expected to get on a traditional sales. So if we can manage to sell higher than your expectations, we charge 7.5% on the uplift margin (not on transaction value). So we grow when you grow',
		},
	];

	return (
		<div className="min-h-screen bg-white">
			{/* Hero Section */}
			<section
				id="hero-merchant"
				className="relative py-10 sm:py-20 overflow-hidden min-h-screen flex"
				style={{
					backgroundImage: `url(${AiShakehandImg})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
				}}
			>
				{/* Overlay for better text readability */}
				<div className="absolute inset-0 bg-black opacity-70"></div>

				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 relative z-10 flex flex-col justify-center sm:justify-around">
					<div className="text-center mb-8 sm:mb-0">
						{/* Haggle Logo */}
						<div className="mb-6 sm:mb-8">
							<img
								src={LogoImg}
								alt="Haggle"
								className="h-16 sm:h-20 md:h-24 lg:h-32 w-auto mx-auto"
							/>
						</div>
					</div>

					{/* Business and Customer Sections */}
					<div className="text-center">
						{/* Main Headline */}
						<h2 className="text-3xl sm:text-4xl md:text-5xl font-medium text-white mb-4 sm:mb-8 lg:mb-12 px-4">
							AI-Powered Negotiation for E-Commerce
						</h2>
						<h3 className="text-xl sm:text-2xl font-medium text-purpleBrand-300 mb-4 sm:mb-8 lg:mb-12 px-4">
							B2B2C SaaS Solution
						</h3>

						<div className="text-center">
							<button
								className="bg-purpleBrand-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base"
								onClick={() =>
									window.open(
										`${import.meta.env.VITE_FRONTEND_URL}/auth/sign-up/`,
										'_blank',
									)
								}
							>
								Sign Up For Free
							</button>
						</div>
					</div>
				</div>
			</section>

			{/* Customer Engagement Section */}
			<section
				id="customer-engagement"
				className="py-12 sm:py-16 lg:py-20 bg-gray-50 text-[#091C53]"
			>
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
					<div className="text-center">
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12 lg:mb-16 px-4">
							Customer Engagement with Event-Based Personalized Offering
						</h2>
						<div className="max-w-4xl mx-auto mb-6 sm:mb-8">
							<div className="relative bg-gray-900 rounded-xl overflow-hidden shadow-2xl">
								<div className="aspect-video">
									<iframe
										width="100%"
										height="100%"
										src="https://www.youtube.com/embed/qopjPFERRc0"
										title="Haggle Demo Video"
										frameBorder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
										allowFullScreen
										className="rounded-xl"
									></iframe>
								</div>
							</div>
						</div>
						<button
							className="bg-purpleBrand-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base"
							onClick={() =>
								window.open(
									`${import.meta.env.VITE_FRONTEND_URL}/auth/sign-up/`,
									'_blank',
								)
							}
						>
							Sign Up For Free
						</button>
					</div>
				</div>
			</section>

			{/* Customer Engagement Section */}
			<section
				id="solution"
				className="py-12 sm:py-16 lg:py-20 bg-white text-[#091C53]"
			>
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-50">
					{/* Main Title */}
					<div className="text-center mb-12 sm:mb-16">
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-8">
							Customer Engagement with Event-Based Personalized Offering
						</h2>
					</div>

					{/* AI-Powered Sales Agent Section */}
					<div className="mb-16">
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
							{/* Left side - Content and Metrics */}
							<div className="space-y-8 text-center">
								<div>
									<h3 className="text-lg sm:text-xl font-bold mb-4 text-purpleBrand-500">
										AI-Powered Sales Agent/Negotiator
									</h3>
									<p className="text-base sm:text-lg text-gray-600 mb-8">
										Real-time Engagement through an intuitive Chatbot
									</p>
								</div>

								{/* Metrics */}
								<div className="flex flex-col sm:flex-row gap-6 sm:gap-8 justify-center">
									<div className="flex flex-col items-center">
										<div className="relative w-24 h-24 mb-4">
											<svg
												className="w-24 h-24 transform -rotate-90"
												viewBox="0 0 100 100"
											>
												<circle
													cx="50"
													cy="50"
													r="40"
													fill="none"
													stroke="#E5E7EB"
													strokeWidth="8"
												/>
												<circle
													cx="50"
													cy="50"
													r="40"
													fill="none"
													stroke="#653AAA"
													strokeWidth="8"
													strokeDasharray={`${2 * Math.PI * 40 * 0.24} ${
														2 * Math.PI * 40
													}`}
													strokeLinecap="round"
												/>
											</svg>
											<div className="absolute inset-0 flex items-center justify-center">
												<span className="text-lg font-bold text-gray-800">
													24%
												</span>
											</div>
										</div>
										<p className="text-sm font-medium text-gray-600 text-center">
											Higher Conversion
										</p>
									</div>

									<div className="flex flex-col items-center">
										<div className="relative w-24 h-24 mb-4">
											<svg
												className="w-24 h-24 transform -rotate-90"
												viewBox="0 0 100 100"
											>
												<circle
													cx="50"
													cy="50"
													r="40"
													fill="none"
													stroke="#E5E7EB"
													strokeWidth="8"
												/>
												<circle
													cx="50"
													cy="50"
													r="40"
													fill="none"
													stroke="#653AAA"
													strokeWidth="8"
													strokeDasharray={`${2 * Math.PI * 40 * 0.35} ${
														2 * Math.PI * 40
													}`}
													strokeLinecap="round"
												/>
											</svg>
											<div className="absolute inset-0 flex items-center justify-center">
												<span className="text-lg font-bold text-gray-800">
													35%
												</span>
											</div>
										</div>
										<p className="text-sm font-medium text-gray-600 text-center">
											Increased Return Rate
										</p>
									</div>
								</div>
							</div>

							{/* Right side - Robot Image */}
							<div className="flex justify-center lg:justify-end">
								<img
									src={RobotSlidesImg}
									alt="AI Robot with Chat Interface"
									className="max-w-full h-auto w-full max-w-lg"
									style={{ maxHeight: '500px' }}
								/>
							</div>
						</div>
					</div>

					{/* Industry Applications */}
					<div className="mt-16">
						<div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
							{/* Travel */}
							<div className="bg-white border-2 border-purple-200 rounded-xl py-4 px-2 text-center hover:shadow-lg transition-shadow">
								<h4 className="text-xl font-bold text-gray-800 mb-4">Travel</h4>
								<div className="space-y-2 text-gray-600 text-xs">
									<p>Airlines, Cruises, Hotels, Attractions</p>
								</div>
							</div>

							{/* Retail */}
							<div className="bg-white border-2 border-purple-200 rounded-xl py-4 px-2 text-center hover:shadow-lg transition-shadow">
								<h4 className="text-xl font-bold text-gray-800 mb-4">Retail</h4>
								<div className="space-y-2 text-gray-600 text-xs">
									<p>Electronics, Furniture, Fashion, Accessories</p>
								</div>
							</div>

							{/* Services */}
							<div className="bg-white border-2 border-purple-200 rounded-xl py-4 px-2 text-center hover:shadow-lg transition-shadow">
								<h4 className="text-xl font-bold text-gray-800 mb-4">
									Services
								</h4>
								<div className="space-y-2 text-gray-600 text-xs">
									<p>Events, Wellness, Pet Care, Education, SaaS</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Why Haggle Was Created Section */}
			<section
				id="why-haggle"
				className=" min-h-screen px-5 py-12 sm:py-16 lg:py-20 text-[#091C53] relative"
				style={{
					backgroundImage: `url(${WorldImg})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
				}}
			>
				{/* Overlay for better text readability */}
				<div className="absolute inset-0 bg-white opacity-80"></div>
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 relative z-10">
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
						{/* Left side - Text content */}
						<div className="space-y-6 sm:space-y-8">
							<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-purpleBrand-500">
								Why Haggle Was Created
							</h2>

							<p className="text-base sm:text-lg leading-relaxed">
								Haggle was created by retailers who were tired of endless
								discount wars and fake loyalty schemes.
							</p>

							<p className="text-base sm:text-lg leading-relaxed">
								As a leading AI company, we designed a negotiation engine that
								helps customers and merchants truly connect -{' '}
								<strong>
									understanding real needs and budgets before pushing another
									sale.
								</strong>
							</p>

							<p className="text-base sm:text-lg leading-relaxed">
								This is the <strong>new era of shopping</strong>: smarter,
								fairer, and more rewarding for everyone.
							</p>
						</div>

						{/* Right side - Robotic hand image */}
						<div className="flex justify-center order-2 lg:order-1">
							<div className="relative">
								<img
									src={BulbImg}
									alt="AI Robot Hand with Lightbulb"
									className="w-full max-w-sm sm:max-w-md h-auto"
								/>
							</div>
						</div>
					</div>
					{/* Industry Applications */}
					<div className="mt-16">
						<div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
							{/* Travel */}
							<div className="bg-white border-2 border-purple-200 rounded-xl py-4 px-2 text-center hover:shadow-lg transition-shadow">
								<h4 className="text-xl font-bold text-gray-800">
									Capture Lost Sales
								</h4>
							</div>

							{/* Retail */}
							<div className="bg-white border-2 border-purple-200 rounded-xl py-4 px-2 text-center hover:shadow-lg transition-shadow">
								<h4 className="text-xl font-bold text-gray-800">
									Optimize Margins
								</h4>
							</div>

							{/* Services */}
							<div className="bg-white border-2 border-purple-200 rounded-xl py-4 px-2 text-center hover:shadow-lg transition-shadow">
								<h4 className="text-xl font-bold text-gray-800">
									Gain Market Insight
								</h4>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Why Shoppers Love It Section */}
			<section
				id="benefits"
				className="min-h-screen px-5 py-12 sm:py-16 lg:py-20 bg-white text-[#091C53]"
			>
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
					<div className="text-center mb-8 sm:mb-12 lg:mb-16">
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12 px-4 text-purpleBrand-500">
							Why Shoppers Love It
						</h2>
					</div>

					<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
						{/* Left side - Visual */}
						<div className="flex justify-center order-2 lg:order-1">
							<div className="relative">
								<img
									src={NegotiateGirlImg}
									alt="Woman negotiating with AI shopping assistant"
									className="w-full max-w-sm sm:max-w-md h-auto"
								/>
								<div className="absolute bottom-4 left-4 bg-white rounded-lg p-3 shadow-lg">
									<div className="flex items-center space-x-2">
										<div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center">
											<div className="w-3 h-3 bg-white rounded-full"></div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{/* Right side - Benefits */}
						<div className="space-y-6 sm:space-y-8 order-1 lg:order-2">
							<div className="flex items-start space-x-4">
								<div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
									<div className="w-6 h-6 bg-purpleBrand-500 rounded-full flex items-center justify-center">
										<div className="w-3 h-3 bg-white rounded-full"></div>
									</div>
								</div>
								<div>
									<h3 className="text-base sm:text-lg font-medium mb-2">
										Prices that adjust your budget
									</h3>
								</div>
							</div>

							<div className="flex items-start space-x-4">
								<div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
									<FaClock className="w-6 h-6 text-purpleBrand-500" />
								</div>
								<div>
									<h3 className="text-base sm:text-lg font-medium mb-2">
										Exclusive events that disappear fast
									</h3>
								</div>
							</div>

							<div className="flex items-start space-x-4">
								<div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
									<FaComments className="w-6 h-6 text-purpleBrand-500" />
								</div>
								<div>
									<h3 className="text-base sm:text-lg font-medium mb-2">
										Deals on premium products from big-name and boutique brands
									</h3>
								</div>
							</div>

							<div className="flex items-start space-x-4">
								<div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
									<FaGamepad className="w-6 h-6 text-purpleBrand-500" />
								</div>
								<div>
									<h3 className="text-base sm:text-lg font-medium mb-2">
										A shopping experience that feels like a game - but with real
										rewards
									</h3>
								</div>
							</div>

							<div className="flex items-start space-x-4">
								<div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
									<FaShieldAlt className="w-6 h-6 text-purpleBrand-500" />
								</div>
								<div>
									<h3 className="text-base sm:text-lg font-medium mb-2">
										Peace of mind - merchants are vetted, card details are never
										stored and are processed securely
									</h3>
								</div>
							</div>

							<div className="text-center lg:text-left">
								<button
									className="bg-purpleBrand-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base"
									onClick={() =>
										window.open(
											`${import.meta.env.VITE_FRONTEND_URL}/auth/sign-up/`,
											'_blank',
										)
									}
								>
									Join Now For Free
								</button>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Connect Your Store Section */}
			<section className="py-12 sm:py-16 lg:pb-20 bg-white">
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
					<div className="text-center mb-8 sm:mb-12 lg:mb-16">
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12 lg:mb-16 px-4">
							Connect Your Store
						</h2>
						<div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 max-w-4xl mx-auto">
							{/* Shopify Integration */}
							<div className="text-center">
								<div className="flex items-center justify-center mx-auto mb-4 sm:mb-6">
									<img
										src={ShopifyImg}
										alt="Shopify Logo"
										className="w-40 sm:w-50 h-20 sm:h-25"
									/>
								</div>
								<h3 className="text-sm sm:text-base font-bold text-purpleBrand-500 mb-4 px-4">
									A listed App on Shopify App Store
								</h3>
								<button
									className="bg-purpleBrand-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base"
									onClick={() =>
										window.open(
											'https://apps.shopify.com/haggle-app?search_id=bf251aa0-29d7-4c7d-8062-2a82ac7f16e8&surface_detail=haggle&surface_inter_position=1&surface_intra_position=2&surface_type=search',
											'_blank',
										)
									}
								>
									Download For Free
								</button>
							</div>

							{/* General Upload */}
							<div className="text-center">
								<div className="flex items-center justify-center mx-auto mb-4 sm:mb-6">
									<img
										src={UploadImg}
										alt="Upload Icon"
										className="w-40 sm:w-50 h-20 sm:h-24"
									/>
								</div>
								<h3 className="text-sm sm:text-base font-bold text-purpleBrand-500 mb-4 px-4">
									Not on Shopify? Upload Product list
								</h3>
								<button
									className="bg-purpleBrand-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base hover:bg-purpleBrand-600"
									onClick={() =>
										window.open(
											`${import.meta.env.VITE_FRONTEND_URL}/auth/sign-up/`,
											'_blank',
										)
									}
								>
									Sign Up For Free
								</button>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Pricing Section */}
			<section id="pricing" className="py-12 sm:py-15 lg:py-20 text-[#091C53]">
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-40">
					<h2 className="text-2xl sm:text-3xl font-medium text-center mb-8 sm:mb-12 px-4">
						Pricing Model
					</h2>
					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
						{/* Diamond Card */}
						<div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-lg relative">
							<div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
								<div
									className="px-4 py-1 rounded-full text-sm font-bold"
									style={{
										backgroundColor: 'white',
										border: '1px solid #93C5FD',
										color: '#2563EB',
									}}
								>
									DIAMOND
								</div>
							</div>
							<div className="text-center pt-4 text-xs">
								<div
									className="text-2xl font-medium mb-2 bg-white"
									style={{ color: '#1A202C' }}
								>
									$799 +
								</div>
								<p className=" mb-4" style={{ color: '#4A5568' }}>
									Success Fee of 7.5% on Added Revenue
								</p>
								<ul className="text-left space-y-2 text-xs text-gray-600">
									<li>Ruby +</li>
									<li>5,000+ Negotiations per Month</li>
									<li>Hosting Haggle Events for Business Customers (B2B)</li>
									<li>Public, Semi-Private & Private Haggle Event Setting</li>
									<li>B2B Checkout</li>
									<li>Payment Integration for Supplier Pay out</li>
									<li>Enhanced Billing</li>
								</ul>
							</div>
						</div>

						{/* Ruby Card */}
						<div className="bg-white border border-gray-200 p-6 rounded-2xl shadow-lg relative">
							<div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
								<div
									className="px-4 py-1 rounded-full text-sm font-bold"
									style={{
										backgroundColor: 'white',
										border: '1px solid #FCA5A5',
										color: '#DC2626',
									}}
								>
									RUBY
								</div>
							</div>
							<div className="text-center pt-4 text-xs">
								<div
									className="text-2xl font-medium mb-2"
									style={{ color: '#1A202C' }}
								>
									$299 +
								</div>
								<p className=" mb-4" style={{ color: '#4A5568' }}>
									Success Fee of 7.5% on Added Revenue
								</p>
								<ul className="text-left space-y-2 text-xs text-gray-600">
									<li>Sapphire +</li>
									<li>Up to 5,000 Negotiations/Month</li>
									<li>Bulk Product Upload via CSV</li>
									<li>End to End negotiation on haggles.ai</li>
									<li>Full inventory Management</li>
									<li>Access to Supplier Haggle Events</li>
									<li>Favourite Supplier Event Notification</li>
								</ul>
							</div>
						</div>

						{/* Sapphire Card */}
						<div className="bg-white border border-purple-200 p-6 rounded-xl shadow-lg relative">
							<div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
								<div className="bg-white border border-purple-300 text-purple-600 px-4 py-1 rounded-full text-sm font-bold">
									SAPPHIRE
								</div>
							</div>
							<div className="text-center pt-4 text-xs">
								<div
									className="text-2xl font-medium mb-2"
									style={{ color: '#1A202C' }}
								>
									$149 +
								</div>
								<p className=" mb-4" style={{ color: '#4A5568' }}>
									Success Fee of 7.5% on Added Revenue
								</p>
								<ul className="text-left space-y-2 text-xs text-gray-600">
									<li>Emerald +</li>
									<li>Up to 2,000 Negotiations per Month</li>
									<li>Branding Customization</li>
									<li>Bundling/Multiple SKUs Negotiation</li>
									<li>Priority Event Placement on Haggles.ai</li>
									<li>Abuse Limitation</li>
									<li>"Haggle Now" Banner on Listed Products</li>
									<li>Time-Boxed Checkout</li>
								</ul>
							</div>
						</div>

						{/* Emerald Card */}
						<div className="bg-white border border-green-200 p-6 rounded-xl shadow-lg relative">
							<div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
								<div className="bg-white border border-green-300 text-green-600 px-4 py-1 rounded-full text-sm font-bold">
									EMERALD
								</div>
							</div>
							<div className="text-center pt-4 text-xs">
								<div
									className="text-2xl font-medium mb-2"
									style={{ color: '#1A202C' }}
								>
									FREE
								</div>
								<p className=" mb-4" style={{ color: '#4A5568' }}>
									$0 Success Fee on Added Revenue
								</p>
								<ul className="text-left space-y-2 text-xs text-gray-600">
									<li>1,000 Negotiations per Month</li>
									<li>Merchant Dashboard</li>
									<li>Rules Customization</li>
									<li>Expert Negotiator - Chatbot</li>
									<li>Customer Waitlist</li>
									<li>Post-Event Timed Final Offer</li>
									<li>Customer Notifications</li>
									<li>Event Preview on Haggles.ai</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Pledge to Elevate Section */}
			<section
				id="pledge-to-elevate"
				className="hidden sm:block py-12 sm:py-16 lg:py-20 bg-white text-[#091C53]"
			>
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
					<div className="text-center mb-2 sm:mb-4">
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800">
							Pledge to Elevate
						</h2>
					</div>

					{/* Timeline */}
					<div className="relative pt-6 pb-12 sm:py-20">
						{/* Horizontal Line */}
						<div className="absolute top-1/2 left-0 right-0 h-1 bg-blue-200 transform -translate-y-1/2"></div>

						{/* Timeline Steps */}
						<div className="relative flex justify-between items-center">
							{/* Step 1 */}
							<div className="flex flex-col items-center relative">
								<div className="text-center mb-4">
									<h3 className="text-base sm:text-lg font-bold text-purple-600 mb-1">
										Bundling
									</h3>
									<p className="text-xs sm:text-sm text-gray-600">
										Multi-SKU Negotiation
									</p>
								</div>
								<div className="w-1 h-4 bg-blue-200"></div>
								<div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-200 rounded-full flex items-center justify-center relative z-10">
									<span className="text-sm sm:text-lg font-bold text-gray-800">
										1
									</span>
								</div>
							</div>

							{/* Step 2 */}
							<div className="flex flex-col items-center relative">
								<div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-200 rounded-full flex items-center justify-center relative z-10">
									<span className="text-sm sm:text-lg font-bold text-gray-800">
										2
									</span>
								</div>
								<div className="w-1 h-4 bg-blue-200"></div>
								<div className="text-center mt-4">
									<h3 className="text-base sm:text-lg font-bold text-purple-600 mb-1">
										Contextual Visual Search
									</h3>
									<p className="text-xs sm:text-sm text-gray-600">
										Advanced Search Technology
									</p>
								</div>
							</div>

							{/* Step 3 */}
							<div className="flex flex-col items-center relative">
								<div className="text-center mb-4">
									<h3 className="text-base sm:text-lg font-bold text-purple-600 mb-1">
										Competition Pricing
									</h3>
								</div>
								<div className="w-1 h-4 bg-blue-200"></div>
								<div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-200 rounded-full flex items-center justify-center relative z-10">
									<span className="text-sm sm:text-lg font-bold text-gray-800">
										3
									</span>
								</div>
							</div>

							{/* Step 4 */}
							<div className="flex flex-col items-center relative">
								<div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-200 rounded-full flex items-center justify-center relative z-10">
									<span className="text-sm sm:text-lg font-bold text-gray-800">
										4
									</span>
								</div>
								<div className="w-1 h-4 bg-blue-200"></div>
								<div className="text-center mt-4">
									<h3 className="text-base sm:text-lg font-bold text-purple-600 mb-1">
										Enhanced AI Analytics
									</h3>
									<p className="text-xs sm:text-sm text-gray-600">
										Market Insight
									</p>
								</div>
							</div>

							{/* Step 5 */}
							<div className="flex flex-col items-center relative">
								<div className="text-center mb-4">
									<h3 className="text-base sm:text-lg font-bold text-purple-600 mb-1">
										CRM Integration
									</h3>
									<p className="text-xs sm:text-sm text-gray-600">
										Customer Invite-Only Events
									</p>
								</div>
								<div className="w-1 h-4 bg-blue-200"></div>
								<div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-200 rounded-full flex items-center justify-center relative z-10">
									<span className="text-sm sm:text-lg font-bold text-gray-800">
										5
									</span>
								</div>
							</div>

							{/* Step 6 */}
							<div className="flex flex-col items-center relative">
								<div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-200 rounded-full flex items-center justify-center relative z-10">
									<span className="text-sm sm:text-lg font-bold text-gray-800">
										6
									</span>
								</div>
								<div className="w-1 h-4 bg-blue-200"></div>
								<div className="text-center mt-4">
									<h3 className="text-base sm:text-lg font-bold text-purple-600 mb-1">
										Smart Sales Agent
									</h3>
									<p className="text-xs sm:text-sm text-gray-600">
										AI-Driven Concierge
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* FAQ Section */}
			<section
				id="faq"
				className="px-5 py-12 sm:py-16 lg:py-20 text-[#333366] relative"
				style={{
					backgroundImage: `url(${JoinImageImg})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
				}}
			>
				<div className="absolute inset-0 bg-white opacity-80"></div>
				<div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 relative z-10">
					<div className="text-left mb-8 sm:mb-12 lg:mb-16">
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12 px-4 text-purpleBrand-500">
							Frequently Asked Questions (FAQs)
						</h2>
					</div>

					<div className="max-w-4xl space-y-6 sm:space-y-8">
						{faqData.map((faq, index) => (
							<div key={index} className="text-left">
								<button
									className="w-full text-left flex items-start gap-3 hover:opacity-80 transition-opacity duration-200"
									onClick={() => toggleFAQ(index)}
								>
									<FaChevronDown
										className={`w-4 h-4 text-[#333366] mt-1 flex-shrink-0 transition-transform duration-200 ${
											openFAQ === index ? 'rotate-180' : ''
										}`}
									/>
									<span className="text-xl sm:text-2xl font-bold text-[#333366]">
										{faq.question}
									</span>
								</button>
								{openFAQ === index && (
									<div className="ml-7 mt-2">
										<p className="text-base sm:text-lg text-[#333366] leading-relaxed">
											{faq.answer.includes(
												'big-name retailers and boutique brands',
											) ? (
												<>
													A mix of{' '}
													<strong>
														big-name retailers and boutique brands
													</strong>{' '}
													across fashion, beauty, home, sport, electronics,
													travel and more.
												</>
											) : (
												faq.answer
											)}
										</p>
									</div>
								)}
							</div>
						))}
					</div>

					<div className="text-left mt-8 sm:mt-12">
						<button
							className="bg-purpleBrand-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base"
							onClick={() =>
								window.open(
									`${import.meta.env.VITE_FRONTEND_URL}/auth/sign-up/`,
									'_blank',
								)
							}
						>
							Sign Up for Free
						</button>
					</div>
				</div>
			</section>

			{/* Contact Section */}
			<section
				id="contact"
				className="py-12 sm:py-16 lg:py-20 bg-white text-center text-[#091C53]"
			>
				<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
					{/* Header */}
					<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8">
						Contact
					</h2>

					{/* Tagline */}
					<p className="text-base sm:text-lg font-bold mb-12 text-purpleBrand-500">
						The Future of Personalized Pricing in E-Commerce
					</p>

					{/* Two buttons */}
					<div className="flex flex-col gap-4 sm:gap-8 justify-center items-center mb-16">
						<button
							className="bg-purpleBrand-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base"
							onClick={() =>
								window.open(
									`${import.meta.env.VITE_FRONTEND_URL}/auth/sign-up/`,
									'_blank',
								)
							}
						>
							Sign Up For Free
						</button>
						<button
							className="bg-purpleBrand-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full transition-colors cursor-pointer text-sm sm:text-base"
							onClick={() =>
								window.open('https://calendly.com/hamed-haggles', '_blank')
							}
						>
							Need a Demo? Let's Connect!
						</button>
					</div>

					{/* Contact Information */}
					<div className="flex flex-col sm:flex-row justify-center items-center gap-8 sm:gap-12">
						{/* Phone */}
						<div className="flex flex-col items-center">
							<FaPhone className="w-6 h-6 mb-3 text-purpleBrand-500" />
							<span className="font-medium text-purpleBrand-500">
								(+61) 0484 305 452
							</span>
						</div>

						{/* Email */}
						<div className="flex flex-col items-center">
							<FaEnvelope className="w-6 h-6 mb-3 text-purpleBrand-500" />
							<span className="font-medium text-purpleBrand-500">
								hamed@haggles.ai
							</span>
						</div>

						{/* Website */}
						<div className="flex flex-col items-center">
							<FaGlobe className="w-6 h-6 mb-3 text-purpleBrand-500" />
							<span className="font-medium text-purpleBrand-500">
								haggles.ai
							</span>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default Merchants;
